module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Misc</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4 prop-sublabel\">Separator Color</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"seperatorC\" name=\"seperatorColor\" type=\"color\" value=\"")
    ; __append(escapeFn( seperatorColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n            <input id=\"seperatorColor\" name=\"seperatorColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( seperatorColor ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row themeTextRows\">\r\n        <div class=\"col-md-4  prop-sublabel\">Separator Size</div>\r\n        <div class=\"col-md-8 nopadding\">\r\n            <input id=\"seperatorSize\" name=\"seperatorSize\" type=\"text\" style=\"width:50px;\" value=\"")
    ; __append(escapeFn( seperatorSize ))
    ; __append("\" /> px\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}